var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToilet = function SvgIcToilet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.882 6.054a1.598 1.598 0 1 0 0-3.196 1.598 1.598 0 0 0 0 3.196M15.268 15.905l-1.192-4.628a.51.51 0 0 0-.495-.385h-2.289l-.196-1.2h2.115a.77.77 0 0 0 .769-.768.77.77 0 0 0-.77-.77h-2.367l-.024-.152a1.696 1.696 0 0 0-1.766-1.42 1.7 1.7 0 0 0-1.517 2.256l1.221 3.485a.51.51 0 0 0 .484.342h3.34l1.05 3.68a.851.851 0 0 0 1.641-.445z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.323 14.886a3.06 3.06 0 0 1-2.132.858c-.797 0-1.595-.32-2.179-.9-.58-.581-.9-1.357-.9-2.18 0-.822.299-1.544.843-2.117a.703.703 0 0 0-1.018-.969 4.47 4.47 0 0 0-1.231 3.087 4.46 4.46 0 0 0 1.313 3.172q.621.62 1.424.96a4.4 4.4 0 0 0 1.748.353 4.46 4.46 0 0 0 3.108-1.253.703.703 0 0 0-.972-1.015z"
  })));
};
export default SvgIcToilet;